import React, { useEffect, useState, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainPointsSection } from '../components/PainPointsSection';
import { SolutionSection } from '../components/SolutionSection';
import { PillarsSection } from '../components/PillarsSection';
import { PackageSection } from '../components/PackageSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { OfferSection } from '../components/OfferSection';
import { LegalAccordion } from '../components/LegalAccordion';
import { ArrowRight } from 'lucide-react';
export function LandingPage() {
  const [showStickyCta, setShowStickyCta] = useState(false);
  useEffect(() => {
    if (document.querySelector('script[src*="googletagmanager.com/gtag/js?id=AW-17926276899"]')) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17926276899';
    document.head.appendChild(script);
    (window as any).dataLayer = (window as any).dataLayer || [];
    function gtag(...args: any[]) {
      ;
      (window as any).dataLayer.push(args);
    }
    ;
    (window as any).gtag = gtag;
    gtag('js', new Date());
    gtag('config', 'AW-17926276899');
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setShowStickyCta(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-white" data-id="element-180">
      <HeroSection data-id="element-181" />
      <PainPointsSection data-id="element-182" />
      <SolutionSection data-id="element-183" />
      <PillarsSection data-id="element-184" />
      <PackageSection data-id="element-185" />
      <SocialProofSection data-id="element-186" />
      <OfferSection data-id="element-187" />

      <footer className="bg-gray-50 py-12" data-id="element-188">
        <div className="max-w-7xl mx-auto px-4 text-center text-sm text-gray-500" data-id="element-189">
          <p data-id="element-190">
            © {new Date().getFullYear()} Hogar Blindado. Todos los derechos
            reservados.
          </p>
          <p className="mt-2" data-id="element-191">
            Este producto no sustituye el consejo profesional.
          </p>
          <LegalAccordion data-id="element-192" />
        </div>
      </footer>

      {/* Sticky Mobile CTA */}
      {showStickyCta && <div className="fixed bottom-0 left-0 right-0 z-50 p-3 bg-white/95 backdrop-blur-sm border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] lg:hidden" data-id="element-193">
          <a href="https://go.hotmart.com/M104264502J?dp=1" target="_blank" rel="noopener noreferrer" className="w-full px-6 py-3.5 bg-[#1e4d7b] hover:bg-[#163a5e] text-white font-bold rounded-lg shadow-lg flex items-center justify-center gap-2 text-base" data-id="element-194">
            Quiero acceso — 6,50€
            <ArrowRight className="h-5 w-5" data-id="element-195" />
          </a>
        </div>}
    </div>;
}